class Upload {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        const file = document.querySelector('[data-upload-file]')
        document.querySelectorAll('[data-upload]').forEach(el => {
            new UploadElement(el, file)
        })
    }
}

class UploadElement {
    constructor(element, file) {
        this.element = element
        this.file = file
        this.init()
    }
    init() {
        this.url = this.element.dataset.upload;
        this.idx = this.element.dataset.uploadIdx;
        this.actionAdd = this.element.querySelector('[data-upload-add]')
        this.actionAdd.addEventListener('click', () => {
            this.actionUpload()
        })
        this.handlerX = this.startUpload.bind(this)
    }
    actionUpload() {
        this.file.addEventListener('change', this.handlerX, false)
        this.file.click()
    }
    startUpload() {
        this.upload(this.file.files[0])
    }
    upload(file) {
        const data = new FormData();
        data.append('file', file);
        fetch(this.url,
            {
                method: 'POST',
                body: data
            })
            .then((response) => {
                return response.json();
            })
            .then((file) => {
                console.log(file)
                this.showImage(file.id, file.url)
            })
            .catch((error) => {
                console.log(error)
                alert('Erro ao enviar arquivo')
            })
            .then((file) => {
                this.file.removeEventListener('change', this.handlerX, false)
            })
    }
    showImage(id, url) {
        const html = '<div class="item-sk"><input type="hidden" value="' + id + '" name="photo[' + this.idx + '][]" /><img class="img img-xpto2" src="' + url + '"></div>'
        const el = document.createElement('template')
        el.innerHTML = html
        this.element.insertBefore(el.content, this.actionAdd)
    }
}

export default Upload